import api from "./request";

export const createFoodOrderRequest = (data) => {
    return api
        .request("order/create")
        .withBody(data)
        .post();
};

export const pickedupPreOrder = (data) => {
    return api
        .request("order/pickedupPreOrder")
        .withBody(data)
        .post();
};

export const removeFoodOrderRequest = (orderId) => {
    return api
        .request("order/" + orderId)
        .delete();
};

export const getLimitOrdersRequest = () => {
    return api
        .request("order/limit")
        .get();
};

export const getOrdersStatistic = (params) => api
    .request('order/statistic')
    .withParams(params)
    .get();

export const cancelRecentlyMadeOrders = (data) => {
    return api
        .request("order/cancel-pickup")
        .withBody(data)
        .post();
};
